import { Filter } from 'iconoir-react'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import MainLayout from '../layouts/MainLayout'
import { PROPOSAL_TYPE, WORK_STATUS, submissionMenu } from '../utils/constants'
import { Spin, message } from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Button, useTheme } from '@mui/material'
import queryString from 'query-string'
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import UnreadText from '../components/common/UnreadText'
import {
  findCreater,
  findHandler,
  getNameInCapitalize,
  TextWrap,
} from '../utils/common'
import { EmptyText } from '../components/common/CellText'
import moment from 'moment'
import { DATE_FORMAT_SLASH } from '../utils/constants'
import EmptyData from '../components/image/EmptyData'
import SkeletonTable from '../components/Skeleton/SkeletonTable'
import { MdManageAccounts, MdOutlineTimer } from 'react-icons/md'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import {
  AiFillCaretRight,
  AiFillStar,
  AiOutlineCheckCircle,
  AiOutlineStar,
} from 'react-icons/ai'
import { FcOk } from 'react-icons/fc'
import CreateModal from '../modules/Proposal/CreateModal'
import ProposalSalaryRequestTable from '../modules/SalaryRequest/ProposalSalaryRequestTable'
import SearchAdvance from '../modules/SalaryRequest/SearchAdvance'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box className="pt-2 ">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
const ProposalSalaryRequestPage = ({
  proposalStore,
  proposalTypeStore,
  proposalSalaryStore,
}) => {
  const { proposalList } = proposalStore

  const { proposalSalaryLList, proposalSalaryTotal } = proposalSalaryStore
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
  const navigate = useNavigate()
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    keyword: undefined,
    proposal_status: undefined,
    type: undefined,
    proposal_permission: undefined,
  })
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [loading, setLoading] = useState(true)

  const [openSearchAdvance, setOpenSearchAdvance] = useState(false)

  const [openContent, setOpenContent] = useState(false)
  const [openHandler, setOpenHandler] = useState(false)
  const [openCre, setOpenCre] = useState(false)

  const [proposalTypes, setProposalTypes] = useState([])
  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([])
  // sử lý thêm loại khác vào submissionMenu
  useEffect(() => {
    ;(async () => {
      proposalStore.clearFilterProposal()
      const response = await proposalTypeStore.getProposalTypes()
      setProposalTypes(response.data)
      const newProposalTypes = [
        {
          id_group: '3',
          name_group: 'Hành chính - Khác',
          child: response.data
            .filter(item => item.id.includes('OTHER_'))
            .map(item => ({
              id_child: item.id,
              name_child: item.name,
            })),
        },
      ]
      const updatedSubmissionMenu = submissionMenu.concat(newProposalTypes)
      setArrSubmissionMenu(updatedSubmissionMenu)
    })()
  }, [])

  /** Hiển thị danh sách loại phiếu trình (Lọc theo loại phiếu trình) */
  const showSubmissionMenu = useMemo(() => {
    return arrSubmissionMenu?.length >= 3 ? (
      arrSubmissionMenu?.map((unit, index) => {
        return (
          <optgroup
            style={{ color: '#2c65ac', fontWeight: '500' }}
            label={unit.name_group}
            key={unit.id_group}>
            {unit?.child.map(child => {
              return (
                <option
                  style={{
                    marginLeft: '10px',
                    color: '#000000DE',
                    fontWeight: '400',
                  }}
                  value={child.id_child}
                  key={child.id_child}>
                  {child.name_child}
                </option>
              )
            })}
          </optgroup>
        )
      })
    ) : (
      <></>
    )
  }, [arrSubmissionMenu])
  //Lấy danh sách các cấp duyệt
  const [approvalTemplates, setApprovalTemplates] = useState([])

  const getApprovalTemplates = async () => {
    try {
      const response = await proposalStore.getApprovalTemplateListV2()
      setApprovalTemplates(response.data)
    } catch (err) {
      // console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    }
  }
  useEffect(() => {
    ;(async () => {
      try {
        await getApprovalTemplates()
      } catch (err) {
        // console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [])

  const getProposals = async params => {
    try {
      await proposalSalaryStore.getProposalSalaryList(params)
    } catch (error) {
      // console.log(error)
    } finally {
    }
  }
  useEffect(() => {
    const params = {
      page: proposalSalaryStore?.filterPage || filter.page,
      size: proposalSalaryStore?.filterSize || filter.size,
      keyword: proposalSalaryStore?.filterKeyword || filter.keyword,
      proposal_status:
        proposalSalaryStore?.filterProposalStatus || filter.proposal_status,
      type: 'PROPOSAL_SALARY',
      proposal_permission:
        proposalSalaryStore?.filterProposalPermission ||
        filter.proposal_permission,
    }

    setFilter(params)
    ;(async () => {
      setLoading(true)
      proposalSalaryStore.clearProposalSalaryList()
      await getProposals(params)
      setLoading(false)
      setIsRefreshPage(false)
    })()
  }, [proposalSalaryStore])

  useEffect(() => {
    if (isRefreshPage) return
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    })
    navigate({
      pathname: '/proposal-salary-request',
      search: queryStringStringify,
    })
    ;(async () => {
      try {
        setLoading(true)
        proposalSalaryStore.clearProposalSalaryList()
        await getProposals(filter)
        setLoading(false)
      } catch (err) {
        // console.log(err)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])

  function createData(
    title,
    calories,
    fat,
    carbs,
    important,
    proposal_status,
    has_subwork,
    code,
    parent_id
  ) {
    return {
      title,
      calories,
      fat,
      carbs,
      important,
      proposal_status,
      has_subwork,
      code,
      parent_id,
    }
  }
  const theme = useTheme()
  const formatData = dataList => {
    return dataList?.map(record =>
      createData(
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            lineHeight: '25px',
            WebkitLineClamp: '2',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            maxHeight: '50px',
            padding: '4px',
            color: theme.color.primary,
          }}>
          {record?.title}
        </div>,
        <UnreadText
          text={
            record?.assignees &&
            getNameInCapitalize(
              findHandler(record?.assignees)[0].name_uppercase
            )
          }
          isUnread={checkUnread(record)}
          width={'100%'}
        />,
        <UnreadText
          text={
            <div className="flex gap-2">
              <MdManageAccounts size={14} color={theme.color.primary} />
              <div style={{ fontSize: 12 }}>
                {record?.assignees &&
                  findCreater(record?.assignees).map(item =>
                    getNameInCapitalize(item.name_uppercase)
                  )}
              </div>
              <AiFillCaretRight
                style={{
                  margin: '3px 5px 0 5px',
                  minWidth: '10px',
                  color: theme.color.primary,
                }}
                size={14}
              />
            </div>
          }
          isUnread={checkUnread(record)}
          width={'100%'}
        />,
        <UnreadText
          text={
            <div className="flex gap-2 items-center justify-between">
              <MdOutlineTimer color={theme.color.primary} size={14} />
              <div style={{ fontSize: 12 }}>
                {record?.due_date ? (
                  moment(record?.due_date).format(DATE_FORMAT_SLASH)
                ) : (
                  <TextWrap>
                    <EmptyText>Không rõ</EmptyText>
                  </TextWrap>
                )}
              </div>
            </div>
          }
          isUnread={checkUnread(record)}
          width={'100%'}
        />,
        record?.important === true ? (
          <AiFillStar size={14} color="rgb(255,199,0)" />
        ) : (
          <AiOutlineStar size={14} />
        ),
        record?.proposal_status === WORK_STATUS.COMPLETE ? (
          <FcOk size={14} />
        ) : (
          <AiOutlineCheckCircle size={14} color="#a2a2a2" />
        ),
        record?.import,
        record?.code,
        record?.parent_id
      )
    )
  }
  const checkUnread = record => record.is_read !== true
  const rows = formatData(proposalSalaryLList)
  const [hasMore, setHasMore] = useState(false)
  const [value, setValue] = useState(0)
  const [searchParams] = useSearchParams()
  const { params } = useParams()
  const permissionParam = searchParams.get('proposal_permission')
  useEffect(() => {
    if (permissionParam == 'CREATE') {
      setValue(1)
    } else {
      setValue(0)
    }
  }, [])
  // Khi thay đổi tab thì set lại hasMore, clear filter rồi set lại filter
  const handleChange = async (event, newValue) => {
    setValue(newValue)

    let permission = ''
    if (newValue === 0) {
      permission = undefined
    } else if (newValue === 1) {
      permission = 'CREATE'
    }

    setFilter({
      ...filter,
      page: 0, // Đặt lại page của filter
      proposal_permission: permission,
    })

    proposalSalaryStore.clearProposalSalaryList()
    proposalSalaryStore.clearQueryParams()

    // Đặt lại page trong store
    proposalSalaryStore.defaultQueryParams.page = 0
    proposalSalaryStore.filterPage = 0

    proposalSalaryStore.getProposalSalaryList({
      ...filter,
      page: 0,
      size: filter.size,
    })
  }

  const [infiniteLoading, setInfiniteLoading] = useState(false)

  const fetchMoreData = async () => {
    // If the list length already meets or exceeds the total, stop further loading
    if (proposalSalaryLList.length >= proposalSalaryTotal) {
      setHasMore(false)
      return
    }

    try {
      // Increase page count in store, fetching exactly 10 items
      proposalSalaryStore.incrementPage()
      const pageSize = 10

      // Fetch only if the next page will not exceed the total
      const itemsNeeded = proposalSalaryTotal - proposalSalaryLList.length
      const fetchSize = itemsNeeded < pageSize ? itemsNeeded : pageSize

      await proposalSalaryStore.getProposalSalaryList({
        ...filter,
        page: proposalSalaryStore.filterPage,
        size: fetchSize, // Use only the required amount for the last fetch
      })

      // Set hasMore to false if we've reached the total
      if (proposalSalaryLList.length >= proposalSalaryTotal) {
        setHasMore(false)
      }
    } catch (err) {
      // console.error(err)
    }
  }

  useEffect(() => {
    if (proposalSalaryLList.length < proposalSalaryTotal) {
      setHasMore(true)
    } else {
      setHasMore(false) // Stop if we've reached or exceeded total
    }
  }, [proposalSalaryLList.length, proposalSalaryTotal])

  useEffect(() => {
    proposalSalaryStore.clearProposalSalaryList()
  }, [])

  useEffect(() => {
    if (proposalSalaryLList?.length <= proposalSalaryTotal) {
      setHasMore(true)
      return
    }

    proposalSalaryStore.clearProposalSalaryList()
  }, [proposalSalaryLList])
  // chuyển trang khác thì luôn được cuộn lên đầu trang
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  // console.log(JSON.stringify(proposalSalaryLList))
  return (
    <div style={{ background: theme.background.base, minHeight: '850px' }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <div className="font-bold text-[28px] leading-[29px]  ">
          Duyệt lương
        </div>
        <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenSearchAdvance(true)
          }}>
          <Filter />
        </span>
      </div>
      <MainLayout initialValue={5}>
        <div className="pl-2 pr-2 pt-20">
          <Box className="" sx={{}}>
            <Box sx={{}}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example">
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Tất cả"
                  {...a11yProps(0)}
                />
                <Tab
                  className="normal-case text-sm font-semibold leading-[15px]  mb-[14px] min-h-0 "
                  label="Đã gửi"
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
          </Box>
          <Button
            variant="contained"
            color="primary"
            className="mt-4 pr-6 normal-case"
            onClick={() => {
              navigate('/proposal-salary-request/create')
              // message.warning('Tính năng tạm thời đang phát triển!')
            }}>
            Tạo mới trình duyệt lương
          </Button>
          {loading ? (
            <SkeletonTable />
          ) : proposalSalaryLList?.length > 0 ? (
            <>
              <section className="mt-1 pb-[30px] overflow-x-auto hideScrollbar">
                <InfiniteScroll
                  dataLength={proposalSalaryLList.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  style={{
                    scrollSnapStop: 'always',
                  }}
                  scrollThreshold={0.8}
                  loader={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 0,
                      }}>
                      {proposalSalaryLList.length > 10 ? (
                        <Spin tip="Đang tải..." />
                      ) : (
                        ''
                      )}
                    </div>
                  }>
                  <div className="inline-block w-[100%] overflow-visible hideScrollbar ">
                    {proposalSalaryLList?.map((data, index) => (
                      <ProposalSalaryRequestTable key={index} data={data} />
                    ))}
                  </div>
                </InfiniteScroll>
              </section>{' '}
            </>
          ) : (
            <EmptyData />
          )}
        </div>
        <SearchAdvance
          arrSubmissionMenu={arrSubmissionMenu}
          openSearchAdvance={openSearchAdvance}
          handleOpenSearchAdvance={() => {
            setOpenSearchAdvance(true)
          }}
          handleCloseSearchAdvance={() => {
            setOpenSearchAdvance(false)
          }}
          setFilter={setFilter}
          filter={filter}
        />
      </MainLayout>
    </div>
  )
}

export default inject(
  'proposalStore',
  'proposalTypeStore',
  'proposalSalaryStore'
)(observer(ProposalSalaryRequestPage))
